import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';

interface IsModalContextType {
  isAnyModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const IsModalContext = createContext<IsModalContextType | undefined>(undefined);

export const IsModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openModalCount, setOpenModalCount] = useState(0);

  const openModal = useCallback(() => {
    setOpenModalCount((count) => count + 1);
  }, []);

  const closeModal = useCallback(() => {
    setOpenModalCount((count) => Math.max(0, count - 1));
  }, []);

  return (
    <IsModalContext.Provider value={{ isAnyModalOpen: openModalCount > 0, openModal, closeModal }}>
      {children}
    </IsModalContext.Provider>
  );
};

export const useIsModal = (): IsModalContextType => {
  const context = useContext(IsModalContext);
  if (!context) {
    throw new Error('useIsModal must be used within an IsModalProvider');
  }
  return context;
};
